<template>
  <div class="column-editor">
    <p>Displayed columns</p>
    <ul>
      <vue-sortable :options="options" @sortable:sorted="sorted">
        <vue-draggable-container tag="ul">
          <li
            v-for="header in selectedHeaders"
            :key="header.value"
            ref="draggable-item"
            @click="toggleHeader(header.value, true)"
            :class="['exclude', { item: !header.locked }]"
          >
            <input
              type="checkbox"
              :disabled="header.locked"
              checked="true"
              @mouseover="toggleItemClass"
              @mouseout="toggleItemClass"
              class="exclude"
            />
            {{ header.text }}
          </li>
        </vue-draggable-container>
      </vue-sortable>
    </ul>
    <span v-if="availableHeaders.length > 0">
      <p>Available columns</p>
      <ul class="available-headers">
        <li
          v-for="header in availableHeaders"
          :key="header.value"
          @click="toggleHeader(header.value, false)"
          class="exclude"
        >
          <input type="checkbox" :checked="false" class="exclude" />
          {{ header.text }}
        </li>
      </ul>
    </span>

    <div class="d-flex">
      <div class="btn" @click="$emit('resetHeaders')">Reset</div>
      <div class="btn" @click="$emit('saveHeaders')">Save</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    selectedHeaders: {
      type: Array,
      required: true,
    },
    availableHeaders: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      options: {
        draggable: ".item",
        delay: 100
      },
    };
  },
  methods: {
    onClose() {
      this.$emit("close");
    },
    sorted(e) {
      this.$emit("sorted", e);
    },
    toggleHeader(value, selected) {
      this.$emit("toggle", value, selected);
    },
    toggleItemClass(e) {
      let draggebleItem = e.target.parentNode;

      draggebleItem.classList.toggle("item");
    },
  },
};
</script>

<style lang="scss">
.column-editor {
  position: absolute;
  left: 0;
  background: white;
  color: black;
  text-align: left;
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
  border-radius: 0.25rem;
  width: max-content;
  z-index: 100;

  p {
    padding: 20px 20px 0px 20px;
    margin-bottom: 10px;
    font-weight: bold;
  }

  ul {
    list-style: none;
    padding: 0;
    padding-bottom: 8px;

    li {
      list-style: none;
      padding: 5px 20px;
      font-size: 12px;
      cursor: grab;
      display: flex;
      align-items: center;

      &:hover {
        background-color: #99999933;
      }

      &.draggable-source--is-dragging {
        cursor: grabbing;
      }

      input {
        margin-right: 4px !important;
      }
    }

    &.available-headers li {
      cursor: pointer;
    }
  }

  .d-flex {
    justify-content: center;
    margin: 0;
    border-top: 1px solid #0000001f;

    .btn {
      font-size: 12px !important;
      margin: {
        left: 0;
        right: 0;
      }
      border-radius: 0px !important;

      &:first-of-type {
        border-right: 1px solid #0000001f;
      }

      &:last-of-type {
        color: #0081d1;
        border-left: 1px solid transparent;
      }

      padding: 10px 0px 10px 0px;
      width: 100%;
    }
  }
}
</style>